import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import UserDefinedData from './components/UserDefinedData';
import Monitoring from './components/Monitoring';
import NonFuelAreas from './components/NonFuelAreas';
import LogIn from './components/Login';
import IframeLoginHandler from './components/IframeLoginHandler';
import SharePosition from './components/SharePosition';

function App() {
  return (
    <Router>
      <IframeLoginHandler />
      <Routes>
        <Route path="/user-defined-data" element={<UserDefinedData />} />
        <Route path="/monitoring" element={<Monitoring />} />
        <Route path="/share-position" element={<SharePosition />} />
        <Route path="/non-fuel-areas" element={<NonFuelAreas />} />
        <Route path="/login" element={<LogIn />} />
        {/* Redirect unmatched routes (including "/") to /user-defined-data */}
        <Route path="*" element={<Navigate to="/user-defined-data" />} />
      </Routes>
    </Router>
  );
}

export default App;
